import { ROUTES } from '@shared/constants/routes';

export const DOCUMENTS = [
  {
    key: 0,
    label: 'Согласие на обработку персональных данных\nметрическими программами',
    url: ROUTES.CONSENT_PERSONAL_DATA_METRIC
  },
  {
    key: 1,
    label: 'Согласие на обработку персональных данных',
    url: ROUTES.CONSENT_PERSONAL_DATA
  },
  {
    key: 2,
    label: 'Пользовательское соглашение',
    url: ROUTES.USER_AGREEMENT
  },
  {
    key: 3,
    label: 'Политика обработки файлов cookie',
    url: ROUTES.COOKIES_POLICY
  },
  {
    key: 4,
    label: 'Публичная оферта',
    url: ROUTES.PUBLIC_OFFER
  },
  {
    key: 5,
    label: 'Положение об обработке персональных данных',
    url: ROUTES.PERSONAL_DATA
  }
];
